import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import Reveal from "react-awesome-reveal"

export default class LinkTiles extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tiles: props.links,
    }
  }

  render() {
    const svgIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.svgIcon)
    const headlineAnimationType = SelectionFactoryHelper.getFromSelectionFactory(this.props.headlineAnimation.type)
    const lastTileAnimationType = SelectionFactoryHelper.getFromSelectionFactory(this.props.lastTileAnimation.type)
    const backgroundColors = {
      "--block-bg": this.props.backgroundColor,
      "--tile-hover": this.props.hoverBackgroundColor,
      "--tile-bg": this.props.tileBackgroundColor,
      "--last-tile-bg": this.props.linkBackgroundColor,
      "--last-tile-hover": this.props.linkHoverBackgroundColor,
    }

    const hasIcon = !!this.props.iconUpload || svgIcon !== "None"
    return (
      <div className={`w--wider nomobilemargin`}>
        <div className={`linkcloud-box`} style={backgroundColors}>
          <div className="contentside">
            {!hasIcon ? (
              ""
            ) : (
              <div className="iconarea">
                {this.props.iconUpload ? (
                  <img src={this.props.iconUpload} />
                ) : (
                  <Svg iconName={svgIcon} fillColor={this.props.backgroundColor} stroke={"#fff"} renderContainer={false} />
                )}
              </div>
            )}
            <Reveal
              keyframes={headlineAnimationType ? headlineAnimationType : null}
              className={headlineAnimationType ? "" : "disable-reveal"}
              duration={this.props.headlineAnimation.duration}
              delay={this.props.headlineAnimation.delay}
              fraction={1}
              triggerOnce
            >
              <h2 dangerouslySetInnerHTML={{ __html: this.props.headline ? this.props.headline : "" }}></h2>
            </Reveal>
            <div className="maintext" dangerouslySetInnerHTML={{ __html: this.props.text ? this.props.text : "" }}></div>
          </div>
          <div className="linkside">
            {this.state.tiles && this.state.tiles.length > 0
              ? this.state.tiles.map((link, index) => {
                  let linkTarget
                  if (typeof link.linkTarget === "string" || link.linkTarget instanceof String) {
                    linkTarget = link.linkTarget
                  } else {
                    linkTarget = SelectionFactoryHelper.getFromSelectionFactory(link.linkTarget)
                  }
                  if (link.linkUrl && link.linkText) {
                    if (link.animation) {
                      const animationType = SelectionFactoryHelper.getFromSelectionFactory(link.animation.type)
                      return (
                        <Reveal
                          key={index}
                          keyframes={animationType ? animationType : null}
                          className={animationType ? "cloud-tile" : "cloud-tile disable-reveal"}
                          duration={link.animation.duration}
                          delay={link.animation.delay}
                          fraction={1}
                          triggerOnce
                        >
                          <a href={link.linkUrl} target={linkTarget}>
                            {link.linkText}
                          </a>
                        </Reveal>
                      )
                    }
                    return (
                      <div key={index} className={"cloud-tile disable-reveal"}>
                        <a href={link.linkUrl} target={linkTarget}>
                          {link.linkText}
                        </a>
                      </div>
                    )
                  }
                  return ""
                })
              : ""}
            {this.state.tiles && this.props.linkUrl && this.props.linkText ? (
              <Reveal
                keyframes={lastTileAnimationType ? lastTileAnimationType : null}
                className={lastTileAnimationType ? "cloud-tile last-tile" : "cloud-tile last-tile disable-reveal"}
                duration={this.props.lastTileAnimation.duration}
                delay={this.props.lastTileAnimation.delay}
                fraction={1}
                triggerOnce
              >
                <a href={this.props.linkUrl}>
                  <Svg iconName={"arrowright-slim"} stroke={"#FFF"} fillColor={"none"} renderContainer={false} />
                  {this.props.linkText}
                </a>
              </Reveal>
            ) : (
              ""
            )}
          </div>
          <div className="clear"></div>
        </div>
      </div>
    )
  }
}
